import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger mt-2"
}
const _hoisted_5 = {
  key: 1,
  class: "my-2"
}
const _hoisted_6 = { class: "text-break" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('tokenManagement.loading')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.tokenDataSource,
      "show-borders": true,
      "row-alternation-enabled": true,
      class: "mb-3",
      onRowPrepared: _ctx.onRowPrepared,
      "no-data-text": ""
    }, {
      tokenCellTemplate: _withCtx(({ data }) => [
        _createElementVNode("span", _hoisted_6, _toDisplayString(data.data.refreshTokenHash), 1)
      ]),
      refreshActionCell: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn btn-primary btn-sm",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generateNewToken && _ctx.generateNewToken(...args)))
        }, _toDisplayString(_ctx.$t('tokenManagement.generateNewToken')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxSearchPanel, {
          visible: false,
          "highlight-search-text": true
        }),
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxPaging, { "page-size": 1 }),
        _createVNode(_component_DxPager, {
          "show-info": true,
          "show-navigation-buttons": true,
          "show-page-size-selector": true,
          "allowed-page-sizes": [1, 2, 5]
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "refreshTokenHash",
          caption: _ctx.$t('tokenManagement.currentToken'),
          "cell-template": "tokenCellTemplate",
          "allow-resizing": true,
          width: _ctx.columnWidths.token,
          "min-width": _ctx.isMobile ? 150 : 400
        }, null, 8, ["caption", "width", "min-width"]),
        _createVNode(_component_DxColumn, {
          "data-field": "expiresAt",
          caption: _ctx.$t('tokenManagement.expiresAt'),
          alignment: 'center',
          width: _ctx.columnWidths.expiresAt
        }, null, 8, ["caption", "width"]),
        _createVNode(_component_DxColumn, {
          "data-field": "status",
          caption: _ctx.$t('tokenManagement.status'),
          alignment: 'center',
          width: _ctx.columnWidths.status
        }, null, 8, ["caption", "width"]),
        (_ctx.showActionsColumn)
          ? (_openBlock(), _createBlock(_component_DxColumn, {
              key: 0,
              caption: '',
              alignment: 'center',
              width: _ctx.columnWidths.actions,
              "cell-template": "refreshActionCell"
            }, null, 8, ["width"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "onRowPrepared"])
  ]))
}